const DAY_MS = 24 * 60 * 60 * 1000

/**
 * Floor-days since `createdAtMs`, clamped at 0. Used by `LeadRow` to render a
 * lead's age. (Aging-bucket distribution is now computed server-side in
 * `leadStats.byAge`; the old client-side `bucketize`/`distributionByBucket`
 * were dropped with the SBO-48/52 move.)
 */
export function ageDays(createdAtMs: number, now: Date): number {
  return Math.max(0, Math.floor((now.getTime() - createdAtMs) / DAY_MS))
}
